export const getAddressOptions = (addressArr, selectedId) => {
    return addressArr?.map((item) => (
        {
            label: `${item?.address} (${item?.city})`, 
            value: item?.id, selected: selectedId === item?.id
        })
    )
}

export const getCitiesOptions = (addressArr) => {
    return addressArr?.map((item) => (
        {
            label: item?.city, 
            value: item?.city
        })
    )
}
